import { Component, OnInit } from '@angular/core';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import { FieldType } from '@ngx-formly/core';
import { Observable } from 'rxjs';

interface IOption {
  value: boolean | number;
  label: string;
}

@Component({
    selector: 'app-formly-select-with-buttons-edit-delete',
    template: `
    <div class="field-container">
      <div class="action-btn" *ngIf="!props.onlyDeletion">
        <su-button
          skin="secondary"
          [icon]="editIcon"
          (onClick)="toggleEditMode()"
          *ngIf="props.isEditable"
          [ariaLabel]="editLabel | translate"></su-button>
      </div>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ props.label }}</mat-label>
        <mat-select [formControl]="formControl" [required]="props.required">
          <mat-option
            *ngFor="let option of selectionOptions"
            [value]="option.value">
            {{ option.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div class="action-btn">
        <su-button
          skin="secondary"
          [icon]="'trash'"
          (onClick)="clearValue()"
          *ngIf="props.isDeletable"
          [disabled]="!isEditing"
          [ariaLabel]="'form.delete' | translate"></su-button>
      </div>
    </div>
  `,
    styles: [
        `
      .field-container {
        display: flex;
        align-items: center;
        gap: 8px;
      }
      .full-width {
        flex: 1;
      }
      .action-btn {
        margin-top: -20px;
        width: 60px;
      }
    `,
    ],
    standalone: false
})
export class FormlySelectWithButtonsEditDeleteComponent
  extends FieldType
  implements OnInit
{
  // @ts-ignore
  formControl: FormControl;

  isEditing: boolean = false;

  editIcon: IconName = 'edit';

  editLabel: string = 'form.edit';

  selectionOptions: IOption[] = [];

  ngOnInit() {
    if (this.props.options instanceof Observable) {
      this.props.options.subscribe((data: IOption[]) => {
        this.selectionOptions = data || [];
      });
    } else {
      this.selectionOptions = this.props.options || [];
    }

    if (this.props.onlyDeletion === true) {
      this.isEditing = true;
      return;
    }

    this.formControl.disable();
    if (this.formControl.value === '' || this.formControl.value != null) {
      this.isEditing = true;

      this.formControl.enable();
      this.editIcon = 'x';
      this.editLabel = 'form.reset';
    }
  }

  toggleEditMode() {
    this.isEditing = !this.isEditing;
    if (this.isEditing) {
      this.formControl.enable();
      this.editIcon = 'x';
      this.editLabel = 'form.reset';
      this.formControl.setValue('');
    } else {
      this.formControl.disable();
      this.editIcon = 'edit';
      this.editLabel = 'form.edit';
      this.formControl.setValue(null);
    }
  }

  clearValue() {
    if (this.formControl.value !== null) {
      this.formControl.setValue('');
    }
  }
}
